import { afterRenderEffect, computed, effect, ElementRef, inject, input, signal, untracked, viewChild, } from '@angular/core';
import { AgentSessionStateService } from 'AgentApp/ts/services/agent-session-state.service';
import { AgentSidePanelStateService } from 'AgentApp/ts/services/agent-side-panel-state.service';
import { AgentTransportService } from 'AgentApp/ts/services/agent-transport.service';
import { AgentUserPreferencesService } from 'AgentApp/ts/services/agent-user-preferences.service';
import { ConfirmModalModule } from 'Angular/features/components/modals/confirm-modal/confirm-modal.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { ImageModule } from 'Angular/features/directives/image/image.module';
import { AgentLoaderComponent } from 'AgentApp/ts/features/agent/components/agent-loader/agent-loader.component';
import { AgentResponseMessageComponent } from 'AgentApp/ts/features/agent/components/agent-response-message/agent-response-message.component';
import { AgentStepsComponent } from 'AgentApp/ts/features/agent/components/agent-steps/agent-steps.component';
import { AgentSuggestedPromptsComponent } from 'AgentApp/ts/features/agent/components/agent-suggested-prompts/agent-suggested-prompts.component';
import { AgentTasksComponent } from 'AgentApp/ts/features/agent/components/agent-tasks/agent-tasks.component';
import { AgentToolPermissionBoxComponent, } from 'AgentApp/ts/features/agent/components/agent-tool-permission-box/agent-tool-permission-box.component';
import { AgentUserInputComponent } from 'AgentApp/ts/features/agent/components/agent-user-input/agent-user-input.component';
import { AgentUserMessageComponent } from 'AgentApp/ts/features/agent/components/agent-user-message/agent-user-message.component';
import { PageContextClientTool } from 'AgentApp/ts/client-tools/page-context.client-tool';
import * as i0 from "@angular/core";
import * as i1 from "Angular/features/directives/image/image.directive";
import * as i2 from "../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
const _c0 = ["scrollContainer"];
const _c1 = ["scrollContent"];
const _c2 = ["deleteChatModal"];
const _c3 = () => [];
function AgentSidePanelComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 11)(2, "div", 12);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 13);
    i0.ɵɵtext(5, "How can I help you today?");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 14);
    i0.ɵɵtext(7, "Not sure? ");
    i0.ɵɵelementStart(8, "div", 15);
    i0.ɵɵtext(9, "Ask me what I can do.");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "ycn-agent-suggested-prompts", 16);
    i0.ɵɵlistener("promptSelected", function AgentSidePanelComponent_Conditional_5_Template_ycn_agent_suggested_prompts_promptSelected_10_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onSuggestedPromptSelected($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Hello, ", ctx_r2.user.firstName, ".");
} }
function AgentSidePanelComponent_Conditional_6_For_3_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-agent-user-message", 22);
} if (rf & 2) {
    const message_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("messageText", message_r4.text)("files", message_r4.files);
} }
function AgentSidePanelComponent_Conditional_6_For_3_Conditional_1_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-agent-steps", 25);
    i0.ɵɵlistener("toggled", function AgentSidePanelComponent_Conditional_6_For_3_Conditional_1_Conditional_0_Template_ycn_agent_steps_toggled_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.onStepsToggled($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    const message_r4 = ctx_r5.$implicit;
    const ɵ$index_31_r7 = ctx_r5.$index;
    const ɵ$count_31_r8 = ctx_r5.$count;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("steps", message_r4.steps)("turnComplete", !ctx_r2.chatState().isStreaming || !(ɵ$index_31_r7 === ɵ$count_31_r8 - 1))("expanded", ctx_r2.stepsExpanded());
} }
function AgentSidePanelComponent_Conditional_6_For_3_Conditional_1_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-agent-response-message", 26);
    i0.ɵɵlistener("deleteChat", function AgentSidePanelComponent_Conditional_6_For_3_Conditional_1_Conditional_1_Template_ycn_agent_response_message_deleteChat_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r2 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r2.openDeleteChatModal()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r4 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("messageText", message_r4.text)("displayActions", message_r4.displayActions ?? i0.ɵɵpureFunction0(3, _c3))("displayAsCard", true);
} }
function AgentSidePanelComponent_Conditional_6_For_3_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentSidePanelComponent_Conditional_6_For_3_Conditional_1_Conditional_0_Template, 1, 3, "ycn-agent-steps", 23);
    i0.ɵɵconditionalCreate(1, AgentSidePanelComponent_Conditional_6_For_3_Conditional_1_Conditional_1_Template, 1, 4, "ycn-agent-response-message", 24);
} if (rf & 2) {
    const message_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional((message_r4.steps == null ? null : message_r4.steps.length) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(message_r4.text ? 1 : -1);
} }
function AgentSidePanelComponent_Conditional_6_For_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentSidePanelComponent_Conditional_6_For_3_Conditional_0_Template, 1, 2, "ycn-agent-user-message", 22)(1, AgentSidePanelComponent_Conditional_6_For_3_Conditional_1_Template, 2, 2);
} if (rf & 2) {
    const message_r4 = ctx.$implicit;
    i0.ɵɵconditional(message_r4.role === "user" ? 0 : message_r4.role === "assistant" ? 1 : -1);
} }
function AgentSidePanelComponent_Conditional_6_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-agent-steps", 27);
    i0.ɵɵlistener("toggled", function AgentSidePanelComponent_Conditional_6_Conditional_4_Template_ycn_agent_steps_toggled_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onStepsToggled($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("steps", ctx_r2.currentTaskSteps())("streaming", true)("expanded", ctx_r2.stepsExpanded());
} }
function AgentSidePanelComponent_Conditional_6_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-agent-tool-permission-box", 28);
    i0.ɵɵlistener("confirm", function AgentSidePanelComponent_Conditional_6_Conditional_5_Template_ycn_agent_tool_permission_box_confirm_0_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.onToolPermissionConfirm($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("toolCall", ctx);
} }
function AgentSidePanelComponent_Conditional_6_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-agent-loader", 19);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("currentLoadingText", ctx_r2.currentLoadingText());
} }
function AgentSidePanelComponent_Conditional_6_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelement(1, "img", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("imageSrc", "images/core/ycharts-logo-ai-circle.svg");
} }
function AgentSidePanelComponent_Conditional_6_For_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "ycn-agent-user-message", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const queued_r12 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("messageText", queued_r12.text)("files", queued_r12.files);
} }
function AgentSidePanelComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 2);
    i0.ɵɵrepeaterCreate(2, AgentSidePanelComponent_Conditional_6_For_3_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵconditionalCreate(4, AgentSidePanelComponent_Conditional_6_Conditional_4_Template, 1, 3, "ycn-agent-steps", 17);
    i0.ɵɵconditionalCreate(5, AgentSidePanelComponent_Conditional_6_Conditional_5_Template, 1, 1, "ycn-agent-tool-permission-box", 18)(6, AgentSidePanelComponent_Conditional_6_Conditional_6_Template, 1, 1, "ycn-agent-loader", 19)(7, AgentSidePanelComponent_Conditional_6_Conditional_7_Template, 2, 1, "div", 20);
    i0.ɵɵrepeaterCreate(8, AgentSidePanelComponent_Conditional_6_For_9_Template, 2, 2, "div", 21, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    let tmp_5_0;
    let tmp_6_0;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r2.currentMessages());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(((tmp_5_0 = ctx_r2.currentTaskSteps()) == null ? null : tmp_5_0.length) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_6_0 = ctx_r2.currentToolCallToConfirm()) ? 5 : ctx_r2.isLoading() ? 6 : ctx_r2.showIdleIcon() ? 7 : -1, tmp_6_0);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r2.queuedMessagesForDisplay());
} }
function AgentSidePanelComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8)(1, "button", 30);
    i0.ɵɵlistener("click", function AgentSidePanelComponent_Conditional_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r13); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.scrollToBottom()); });
    i0.ɵɵtext(2, " Scroll Down ");
    i0.ɵɵelementEnd()();
} }
const MAX_AUDIO_CANVAS_WIDTH_ATTACHED = 142;
const MAX_AUDIO_CANVAS_WIDTH_DETACHED = 431;
export class AgentSidePanelComponent {
    constructor() {
        this._connection = inject(AgentTransportService);
        this._panelState = inject(AgentSidePanelStateService);
        this._sessionState = inject(AgentSessionStateService);
        this._preferencesService = inject(AgentUserPreferencesService);
        this._pageContextService = inject(PageContextClientTool);
        this.isDetached = input(false, ...(ngDevMode ? [{ debugName: "isDetached" }] : []));
        this.screen = this._panelState.screen;
        this.pendingNewSessionMessage = this._sessionState.pendingNewSessionMessage;
        this.chatState = computed(() => this._sessionState.getChatState(this._panelState.currentSessionId()), ...(ngDevMode ? [{ debugName: "chatState" }] : []));
        this.currentMessages = computed(() => {
            const pending = this.pendingNewSessionMessage();
            if (pending) {
                return [{ role: 'user', text: pending.text, files: pending.files }];
            }
            return this.chatState().messages;
        }, ...(ngDevMode ? [{ debugName: "currentMessages" }] : []));
        this.isLoading = computed(() => !!this.pendingNewSessionMessage() || this.chatState().isLoading, ...(ngDevMode ? [{ debugName: "isLoading" }] : []));
        this.currentLoadingText = computed(() => this.chatState().currentLoadingText, ...(ngDevMode ? [{ debugName: "currentLoadingText" }] : []));
        this.currentTaskSteps = computed(() => this.chatState().agentSteps, ...(ngDevMode ? [{ debugName: "currentTaskSteps" }] : []));
        this.stepsExpanded = signal(true, ...(ngDevMode ? [{ debugName: "stepsExpanded" }] : []));
        this.currentToolCallToConfirm = computed(() => this.chatState().toolCallsToConfirm[0] ?? null, ...(ngDevMode ? [{ debugName: "currentToolCallToConfirm" }] : []));
        // The icon shown when the agent is waiting for input
        this.showIdleIcon = computed(() => {
            const messages = this.currentMessages();
            const { isStreaming } = this.chatState();
            const liveSteps = this.currentTaskSteps();
            const last = messages[messages.length - 1];
            return !isStreaming && !liveSteps.length && last?.role === 'assistant';
        }, ...(ngDevMode ? [{ debugName: "showIdleIcon" }] : []));
        this.queuedMessagesForDisplay = computed(() => this.chatState().queuedMessages.map((message) => ({
            text: message.text,
            files: message.files.map((file) => ({
                attachment_url: file.name,
                attachment_mime_type: file.type,
                external_file_id: '',
            })),
        })), ...(ngDevMode ? [{ debugName: "queuedMessagesForDisplay" }] : []));
        this._isAgentBusy = computed(() => {
            const state = this.chatState();
            return state.isStreaming || state.toolCallsToConfirm.length > 0;
        }, ...(ngDevMode ? [{ debugName: "_isAgentBusy" }] : []));
        this.visibleTasks = this._sessionState.visibleTasks;
        this.completedTasks = this._sessionState.completedTasks;
        this.inProgressTasks = this._sessionState.inProgressTasks;
        this.cancelledTasks = this._sessionState.cancelledTasks;
        this.taskCompletionPercentage = this._sessionState.taskCompletionPercentage;
        this.hasInProgressTasks = this._sessionState.hasInProgressTasks;
        this.scrollContainer = viewChild('scrollContainer', ...(ngDevMode ? [{ debugName: "scrollContainer" }] : []));
        this.scrollContent = viewChild('scrollContent', ...(ngDevMode ? [{ debugName: "scrollContent" }] : []));
        this.deleteChatModal = viewChild('deleteChatModal', ...(ngDevMode ? [{ debugName: "deleteChatModal" }] : []));
        this.isAtBottom = signal(true, ...(ngDevMode ? [{ debugName: "isAtBottom" }] : []));
        this._isFollowingScroll = signal(true, ...(ngDevMode ? [{ debugName: "_isFollowingScroll" }] : []));
        this.showScrollDownButton = computed(() => {
            const isChatScreen = this.isChatScreen();
            const isAtBottom = this.isAtBottom();
            const currentMessages = this.currentMessages();
            return isChatScreen && !isAtBottom && currentMessages.length > 0;
        }, ...(ngDevMode ? [{ debugName: "showScrollDownButton" }] : []));
        this._autoPausedAtMessagesLength = 0;
        this._lastScrollTop = 0;
        this.isWelcomeScreen = computed(() => {
            const sessionId = this._panelState.currentSessionId();
            const pendingNewSessionMessage = this.pendingNewSessionMessage();
            return sessionId === null && !pendingNewSessionMessage;
        }, ...(ngDevMode ? [{ debugName: "isWelcomeScreen" }] : []));
        this.isChatScreen = computed(() => {
            const sessionId = this._panelState.currentSessionId();
            const pendingNewSessionMessage = this.pendingNewSessionMessage();
            return sessionId !== null || !!pendingNewSessionMessage;
        }, ...(ngDevMode ? [{ debugName: "isChatScreen" }] : []));
        this.user = window.USER;
        // Only populated for users allowed to pick a model; the model is tied to the session once a chat starts.
        this.modelOptions = signal([], ...(ngDevMode ? [{ debugName: "modelOptions" }] : []));
        this.selectedModelId = signal(null, ...(ngDevMode ? [{ debugName: "selectedModelId" }] : []));
        this.maxAudioCanvasWidth = computed(() => {
            const isDetached = this.isDetached();
            if (isDetached) {
                return MAX_AUDIO_CANVAS_WIDTH_DETACHED;
            }
            return MAX_AUDIO_CANVAS_WIDTH_ATTACHED;
        }, ...(ngDevMode ? [{ debugName: "maxAudioCanvasWidth" }] : []));
        // Cancel auto-follow mode if the user scrolls away from the bottom
        effect((onCleanup) => {
            const el = this.scrollContainer()?.nativeElement;
            if (!el) {
                return;
            }
            const onScroll = () => this._syncFromScroll(el);
            el.addEventListener('scroll', onScroll, { passive: true });
            onCleanup(() => el.removeEventListener('scroll', onScroll));
        });
        // Content can grow after the inserting render (like charts after their data loads). afterRenderEffect can't
        // see that, so we watch the content column's height and keep bottom detection in sync with the real
        // content height. All messages render inside #scrollContent, so it tracks late changes.
        effect((onCleanup) => {
            const el = this.scrollContainer()?.nativeElement;
            const content = this.scrollContent()?.nativeElement;
            if (!el || !content) {
                return;
            }
            const observer = new ResizeObserver(() => {
                if (untracked(() => this._isFollowingScroll())) {
                    el.scrollTop = el.scrollHeight;
                }
                this.isAtBottom.set(this._isElementAtBottom(el));
            });
            observer.observe(content);
            onCleanup(() => observer.disconnect());
        });
        // After every render: auto scroll when following, resync bottom detection from the new DOM,
        // and apply aut-pause threshold.
        afterRenderEffect(() => {
            this.isLoading();
            this.currentMessages();
            this.currentTaskSteps();
            this.currentToolCallToConfirm();
            this.queuedMessagesForDisplay();
            const el = this.scrollContainer()?.nativeElement;
            if (!el) {
                return;
            }
            const following = untracked(() => this._isFollowingScroll());
            if (following) {
                el.scrollTop = el.scrollHeight;
            }
            this.isAtBottom.set(this._isElementAtBottom(el));
            if (following) {
                this._applyAutoPauseThreshold(el);
            }
        });
        // Show the model the open session was created with, or the default model for a new chat
        effect(() => {
            const sessionId = this._panelState.currentSessionId();
            const modelOptions = this.modelOptions();
            untracked(() => {
                if (!modelOptions.length) {
                    return;
                }
                if (sessionId === null) {
                    this.selectedModelId.set(modelOptions[0].id);
                    return;
                }
                this._connection
                    .getSession(sessionId)
                    .then((session) => {
                    if (this._panelState.currentSessionId() === sessionId) {
                        this.selectedModelId.set(session.model);
                    }
                })
                    .catch(() => undefined);
            });
        });
        // Reset session state on session change
        effect(() => {
            this._panelState.currentSessionId();
            this._isFollowingScroll.set(true);
            this._autoPausedAtMessagesLength = 0;
            this._lastScrollTop = 0;
        });
        effect(async () => {
            const sessionId = this._panelState.currentSessionId();
            const isAgentBusy = this._isAgentBusy();
            const { queuedMessages } = this.chatState();
            if (!sessionId || isAgentBusy) {
                return;
            }
            if (!queuedMessages.length) {
                return;
            }
            await untracked(async () => {
                const queued = this._sessionState.dequeueAllMessages(sessionId);
                if (!queued.length) {
                    return;
                }
                const smartCompareSecurityIds = [
                    ...new Set(queued.flatMap((message) => message.smartCompareSecurityIds ?? [])),
                ];
                const combined = {
                    text: queued
                        .map((message) => message.text)
                        .filter(Boolean)
                        .join('\n\n'),
                    files: queued.flatMap((message) => message.files),
                    ...(smartCompareSecurityIds.length >= 2 ? { smartCompareSecurityIds } : {}),
                };
                await this.sendMessage(combined);
            });
        });
    }
    ngOnInit() {
        this._preferencesService.get().subscribe(async (prefs) => {
            this.stepsExpanded.set(prefs.agent_side_panel_steps_expanded);
            this.modelOptions.set(prefs.model_options ?? []);
            const savedSessionId = prefs.last_visited_side_menu_session_id;
            if (savedSessionId != null) {
                this._panelState.currentSessionId.set(savedSessionId);
                try {
                    await this._connection.loadAndResumeSession(savedSessionId, window.USER.userId);
                }
                catch {
                    this._panelState.currentSessionId.set(null);
                    this._preferencesService.save({ last_visited_side_menu_session_id: null }).subscribe();
                }
            }
            else {
                // The panel state service outlives this component, so clear any session retained
                // from a previous panel open that the server no longer considers resumable.
                this._panelState.currentSessionId.set(null);
            }
        });
    }
    ngOnDestroy() {
        const sessionId = this._panelState.currentSessionId();
        if (sessionId !== null) {
            this._connection.detach(sessionId);
        }
    }
    onModelChange(modelId) {
        if (!this.isChatScreen()) {
            this.selectedModelId.set(modelId);
        }
    }
    openNewChat() {
        // The previous chat keeps no stream or listener open once it is no longer shown.
        const previousSessionId = this._panelState.currentSessionId();
        if (previousSessionId !== null) {
            this._connection.disconnect(previousSessionId);
        }
        this._panelState.currentSessionId.set(null);
        this._preferencesService.save({ last_visited_side_menu_session_id: null }).subscribe();
    }
    async onSuggestedPromptSelected(prompt) {
        await this.sendMessage({ text: prompt, files: [] });
    }
    onStepsToggled(expanded) {
        this._preferencesService.save({ agent_side_panel_steps_expanded: expanded }).subscribe();
    }
    openDeleteChatModal() {
        this.deleteChatModal()?.openModal();
    }
    onDeleteChatConfirmed(confirm) {
        const sessionId = this._panelState.currentSessionId();
        if (!confirm || sessionId === null) {
            return;
        }
        this.openNewChat();
        this._sessionState.deleteSessionById(sessionId);
    }
    scrollToBottom() {
        this._isFollowingScroll.set(true);
        const el = this.scrollContainer()?.nativeElement;
        if (el) {
            el.scrollTop = el.scrollHeight;
        }
    }
    _isElementAtBottom(el) {
        const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
        return distanceFromBottom <= AgentSidePanelComponent.SCROLL_BOTTOM_THRESHOLD_PX;
    }
    _syncFromScroll(el) {
        const atBottom = this._isElementAtBottom(el);
        // check whether a user actually scrolled up to break auto followns
        const scrolledUp = el.scrollTop < this._lastScrollTop;
        this._lastScrollTop = el.scrollTop;
        this.isAtBottom.set(atBottom);
        if (!atBottom && scrolledUp) {
            this._isFollowingScroll.set(false);
        }
    }
    // Pause auto follow once the BODY of the streamed in message is too tall
    _applyAutoPauseThreshold(el) {
        const messages = untracked(() => this.currentMessages());
        const last = messages[messages.length - 1];
        if (last?.role !== 'assistant' || !last.text || this._autoPausedAtMessagesLength === messages.length) {
            return;
        }
        const textBodies = el.querySelectorAll('ycn-agent-response-message .ai-md');
        const lastTextBody = textBodies[textBodies.length - 1];
        if (lastTextBody &&
            lastTextBody.getBoundingClientRect().height >
                el.clientHeight * AgentSidePanelComponent.AUTO_PAUSE_VIEWPORT_FRACTION) {
            this._autoPausedAtMessagesLength = messages.length;
            this._isFollowingScroll.set(false);
        }
    }
    async sendMessage(message) {
        this._isFollowingScroll.set(true);
        const currentSessionId = this._panelState.currentSessionId();
        if (currentSessionId && this._isAgentBusy()) {
            this._sessionState.enqueueMessage(currentSessionId, message);
            return;
        }
        const sliceKey = await this._pageContextService.getCurrentSliceKey();
        const clientContext = { source: 'side_panel', app_state_slice_key: sliceKey };
        window.pendoTrack('Submitted Input to Agent', {
            message: message.text,
            fileCount: message.files.length,
            source: clientContext.source,
        });
        if (currentSessionId) {
            await this._connection.sendUserMessage(currentSessionId, message.text, message.files, clientContext, message.smartCompareSecurityIds);
        }
        else {
            const selectedModel = this.modelOptions().find((option) => option.id === this.selectedModelId());
            const session = await this._connection.createSession(message.text, message.files, selectedModel ? { provider: selectedModel.provider, model: selectedModel.id } : {});
            this._panelState.currentSessionId.set(session.id);
            this._preferencesService.save({ last_visited_side_menu_session_id: session.id }).subscribe();
            const recentSession = {
                id: session.id,
                name: session.name,
                pinned: false,
                provider: session.provider,
            };
            this._sessionState.addSessionToRecent(recentSession);
            this._connection.generateAndApplySessionDisplay(recentSession, message.text);
            await this._connection.sendUserMessage(session.id, message.text, message.files, clientContext, message.smartCompareSecurityIds);
        }
    }
    onDeleteTask(task) {
        this._sessionState.deleteTask(task);
    }
    onHideTask(task) {
        this._sessionState.hideTask(task);
    }
    onTaskSelected(task) {
        this._sessionState.selectTask(task);
    }
    onToolPermissionConfirm(event) {
        const toolCall = this.currentToolCallToConfirm();
        const sessionId = this._panelState.currentSessionId();
        if (toolCall && sessionId) {
            this._connection.confirmToolCall(sessionId, window.USER.userId, event.authorize, event.alwaysApply, toolCall, event.reason);
        }
    }
}
AgentSidePanelComponent.SCROLL_BOTTOM_THRESHOLD_PX = 50;
AgentSidePanelComponent.AUTO_PAUSE_VIEWPORT_FRACTION = 0.75;
AgentSidePanelComponent.ɵfac = function AgentSidePanelComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentSidePanelComponent)(); };
AgentSidePanelComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentSidePanelComponent, selectors: [["ycn-agent-side-panel"]], viewQuery: function AgentSidePanelComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.scrollContainer, _c0, 5);
        i0.ɵɵviewQuerySignal(ctx.scrollContent, _c1, 5);
        i0.ɵɵviewQuerySignal(ctx.deleteChatModal, _c2, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance(3);
    } }, inputs: { isDetached: [1, "isDetached"] }, decls: 11, vars: 19, consts: [["scrollContainer", ""], ["deleteChatModal", ""], ["scrollContent", ""], [3, "deleteTask", "hideTask", "taskSelected", "visibleTasks", "completedTasks", "inProgressTasks", "cancelledTasks", "completionPercentage", "hasInProgressTasks"], [1, "side-panel-content", "flex-auto", "min-height-0", "d-flex", "flex-column"], [1, "flex-auto", "min-height-0", "relative"], [1, "page-ai-scroll", "z-1", "pt-4", "pl-20", "pr-20"], [1, "height-full", "min-height-200", "d-flex", "flex-column", "justify-content-center", "text-center"], [1, "page-ai", "page-ai-scroll-footer", "text-center", 2, "z-index", "100"], [1, "flex-none", "z-1", "pt-20", "pl-20", "pr-20", "pb-4", 3, "modelChange", "openNewChat", "sendMessage", "maxAudioCanvasWidth", "showNewChatButton", "compactLayout", "modelOptions", "selectedModelId", "modelLocked"], ["confirmHeader", "Delete Chat", "confirmText", "Deleting the chat will remove it from your chat history, including files uploaded and downloaded. Are you sure you want to delete?", "confirmButtonText", "Delete", "cancelButtonText", "Cancel", "modalTestId", "delete-agent-chat", 3, "confirmHandler", "confirmButtonClasses"], [1, "mb-6"], [1, "side-panel-empty-state", "mb-1"], [1, "side-panel-empty-subtitle"], [1, "side-panel-empty-text", "pt-2"], [1, "text-normal"], ["source", "side_panel", 1, "d-block", "mt-5", "pt-20", "text-left", 3, "promptSelected"], [3, "steps", "streaming", "expanded"], [3, "toolCall"], [3, "currentLoadingText"], [1, "section-ai-response-mark"], [2, "opacity", "0.5"], [3, "messageText", "files"], [3, "steps", "turnComplete", "expanded"], [3, "messageText", "displayActions", "displayAsCard"], [3, "toggled", "steps", "turnComplete", "expanded"], [3, "deleteChat", "messageText", "displayActions", "displayAsCard"], [3, "toggled", "steps", "streaming", "expanded"], [3, "confirm", "toolCall"], ["ycnImage", "", "alt", "", 1, "width-24", "height-24", 3, "imageSrc"], [1, "btn", "btn-support", "btn-outline", "btn-ghost", "btn-scroll", 3, "click"]], template: function AgentSidePanelComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-agent-tasks", 3);
        i0.ɵɵlistener("deleteTask", function AgentSidePanelComponent_Template_ycn_agent_tasks_deleteTask_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onDeleteTask($event)); })("hideTask", function AgentSidePanelComponent_Template_ycn_agent_tasks_hideTask_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onHideTask($event)); })("taskSelected", function AgentSidePanelComponent_Template_ycn_agent_tasks_taskSelected_0_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onTaskSelected($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(1, "div", 4)(2, "div", 5)(3, "div", 6, 0);
        i0.ɵɵconditionalCreate(5, AgentSidePanelComponent_Conditional_5_Template, 11, 1, "div", 7)(6, AgentSidePanelComponent_Conditional_6_Template, 10, 2, "div");
        i0.ɵɵelementEnd();
        i0.ɵɵconditionalCreate(7, AgentSidePanelComponent_Conditional_7_Template, 3, 0, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "ycn-agent-user-input", 9);
        i0.ɵɵlistener("modelChange", function AgentSidePanelComponent_Template_ycn_agent_user_input_modelChange_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onModelChange($event)); })("openNewChat", function AgentSidePanelComponent_Template_ycn_agent_user_input_openNewChat_8_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openNewChat()); })("sendMessage", function AgentSidePanelComponent_Template_ycn_agent_user_input_sendMessage_8_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.sendMessage($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "ycn-confirm-modal", 10, 1);
        i0.ɵɵlistener("confirmHandler", function AgentSidePanelComponent_Template_ycn_confirm_modal_confirmHandler_9_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onDeleteChatConfirmed($event)); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("visibleTasks", ctx.visibleTasks())("completedTasks", ctx.completedTasks())("inProgressTasks", ctx.inProgressTasks())("cancelledTasks", ctx.cancelledTasks())("completionPercentage", ctx.taskCompletionPercentage())("hasInProgressTasks", ctx.hasInProgressTasks());
        i0.ɵɵadvance();
        i0.ɵɵclassProp("bg-side-panel-ai", ctx.isWelcomeScreen())("yc-blue-to-panel", !ctx.isWelcomeScreen());
        i0.ɵɵadvance(4);
        i0.ɵɵconditional(ctx.isWelcomeScreen() ? 5 : ctx.isChatScreen() ? 6 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.showScrollDownButton() ? 7 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("maxAudioCanvasWidth", ctx.maxAudioCanvasWidth())("showNewChatButton", true)("compactLayout", true)("modelOptions", ctx.modelOptions())("selectedModelId", ctx.selectedModelId())("modelLocked", ctx.isChatScreen());
        i0.ɵɵadvance();
        i0.ɵɵproperty("confirmButtonClasses", "btn-danger");
    } }, dependencies: [IconModule,
        ImageModule, i1.ImageDirective, ConfirmModalModule, i2.ConfirmModalComponent, AgentUserInputComponent,
        AgentLoaderComponent,
        AgentStepsComponent,
        AgentSuggestedPromptsComponent,
        AgentUserMessageComponent,
        AgentResponseMessageComponent,
        AgentTasksComponent,
        AgentToolPermissionBoxComponent], styles: ["[_nghost-%COMP%] {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n        }"], changeDetection: 0 });
